


















































































import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
/* module */
import Loading from '@/app/components/Common/Loading.vue'
/* api */
import imageApi from '@/app/model/api/getImageApi'

@Component({
  components: {
    Loading
  }
})
export default class GraphImageModal extends Vue {
  private slide: number = 0
  private originalData: string = ''
  private showImgLoading: boolean = true
  private defaultImage: any = '/img/ico_cultivation2.0dd21bea.png'
  private noImage: any = require('@/assets/img/no_image.svg')

  private get showImgModal (): any {
    return this.$store.state.setFlagState.mainImgFlag
  }

  @Watch('showImgModal')
  onChangeModal (flag: boolean) {
    if (flag) {
      this.getOriginalImg(this.$store.state.fieldDetailsState.imgId)
    }
  }

  private getOriginalImg (id: number) {
    (async () => {
      this.showImgLoading = true
      let imgType = 'original'

      let body: any = {
        crop_image_id: id,
        type: imgType
      }
      const result = await imageApi.getImageData(body)
      this.originalData = String(result)
      this.showImgLoading = false
    })()
  }

  private closeModal () {
    this.$store.commit('setFlagState/setMainImgFlag', false)
    this.originalData = ''
    this.$emit('close-modal')
  }
}
